/* Cor do filamento → hex, pra swatches e casamento automático de cor
   detectada num .3mf com o filamento cadastrado mais parecido. Extraído de
   Calculadora.jsx pra ser reaproveitado também pelos novos componentes da
   Calculadora (seleção de filamento na seção "Material"). */

import { CORES_PRESET } from "../constants/colors";

const COR_HEX_FALLBACK = {
  preto:"#1a1a1a", negro:"#1a1a1a", black:"#111",
  branco:"#f0f0f0", white:"#f0f0f0",
  cinza:"#808080", gray:"#808080", grey:"#808080", prata:"#94a3b8", silver:"#94a3b8",
  vermelho:"#dc2626", red:"#dc2626", vinho:"#9f1239",
  azul:"#2563eb", blue:"#2563eb", ciano:"#06b6d4", cyan:"#06b6d4", turquesa:"#2dd4bf",
  verde:"#16a34a", green:"#16a34a", lima:"#84cc16",
  amarelo:"#eab308", yellow:"#eab308",
  laranja:"#ea580c", orange:"#ea580c", coral:"#f97316",
  roxo:"#7c3aed", purple:"#7c3aed", violeta:"#8b5cf6", lilas:"#a78bfa", magenta:"#d946ef",
  rosa:"#ec4899", pink:"#ec4899",
  marrom:"#92400e", brown:"#92400e", bege:"#d4b483", natural:"#f5e6c8",
  cobre:"#b45309", copper:"#b45309", dourado:"#f59e0b", gold:"#f59e0b",
  transparente:"#bae6fd",
};

export function corFilamentoHex(corNome, coresCustom) {
  const c = [...CORES_PRESET, ...(coresCustom || [])].find(c => c.nome === corNome);
  if (c?.hex) return c.hex;
  const lower = (corNome || "").toLowerCase().trim();
  for (const [k, v] of Object.entries(COR_HEX_FALLBACK)) {
    if (lower.includes(k)) return v;
  }
  return "#64748b";
}

function hexToRgb(hex) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

function corDistancia(hexA, hexB) {
  const a = hexToRgb(hexA), b = hexToRgb(hexB);
  if (!a || !b) return Infinity;
  return Math.sqrt((a[0]-b[0])**2 + (a[1]-b[1])**2 + (a[2]-b[2])**2);
}

// Casa uma cor detectada no 3MF com o filamento cadastrado mais parecido
// (distância euclidiana simples em RGB). Sem match "bom o suficiente", deixa
// em branco pro usuário escolher na mão.
// Prioriza PLA, depois PETG, antes de olhar os demais materiais — a maioria
// das impressões usa PLA, e cores parecidas de PETG não devem "roubar" o match.
const PRIORIDADE_MATERIAL = ["PLA", "PETG"];
export function encontrarFilamentoMaisProximo(hex, filamentos, coresCustom) {
  if (!hex) return null;
  const grupos = [
    ...PRIORIDADE_MATERIAL.map(mat => filamentos.filter(f => (f.material||"").toUpperCase() === mat)),
    filamentos.filter(f => !PRIORIDADE_MATERIAL.includes((f.material||"").toUpperCase())),
  ];
  for (const grupo of grupos) {
    let melhor = null, melhorDist = Infinity;
    for (const f of grupo) {
      const d = corDistancia(hex, corFilamentoHex(f.cor, coresCustom));
      if (d < melhorDist) { melhorDist = d; melhor = f; }
    }
    if (melhor && melhorDist <= 60) return melhor;
  }
  return null;
}
